import styled from "styled-components";

const LoginWrapper = styled.div`
  margin: auto;
  max-width: 380px;
  margin-top: 25vh;
`;

export default LoginWrapper;
